import * as api from 'saas/pco/cases/api';
import uid from 'uid';
import { getIsFetching } from '../reducers/tools';
import { getAllUnits } from '../reducers/requirements';

export const FETCH_TOOLS = 'case.FETCH_TOOLS';
export const FETCH_TOOLS_SUCCESS = 'case.FETCH_TOOLS_SUCCESS';
export const ADD_TOOL = 'case.ADD_TOOL';
export const UPDATE_TOOL = 'case.UPDATE_TOOL';
export const DELETE_TOOL = 'case.DELETE_TOOL';

const requestTools = (site, diagnostic) => ({
  type: FETCH_TOOLS,
  site,
  diagnostic,
});

const receiveTools = (site, diagnostic, tools) => ({
  type: FETCH_TOOLS_SUCCESS,
  site,
  diagnostic,
  tools,
});

export const fetchTools = (siteCase, type, site) => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state, site).has(type)) {
    return Promise.resolve();
  }

  dispatch(requestTools(site, type));

  return api
    .getTools(siteCase, type, site)
    .then(res => dispatch(receiveTools(site, type, res)));
};

export const addTool = (type, site) => (dispatch, getState) => {
  const units = getAllUnits(getState());

  const tool = {
    id: uid(),
    new: true,
    quantity: 0,
    quantity_unit_ref: units[0].id,
  };

  dispatch({
    type: ADD_TOOL,
    site,
    diagnostic: type,
    tool,
  });
};

export const updateTool = (type, site, tool, values) => ({
  type: UPDATE_TOOL,
  site,
  diagnostic: type,
  tool: {
    ...tool,
    ...values,
  },
});

export const deleteTool = (type, site, tool) => ({
  type: DELETE_TOOL,
  site,
  diagnostic: type,
  tool,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/actions/tools.js